module.exports = __webpack_public_path__ + "assets/img/companyicon8.055110db.jpg";